import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {AsyncPipe, NgClass} from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';
import {LucideAngularModule} from 'lucide-angular';
import {OverlayService} from '@shared/overlay/overlay.service';
import {Overlay} from '@shared/overlay/overlay';

@Component({
  selector: 'app-overlay',
  imports: [
    AsyncPipe,
    TranslocoDirective,
    NgClass,
    LucideAngularModule
  ],
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.scss'
})
export class OverlayComponent {

  public readonly overlay$: Observable<Overlay | null>;

  public constructor(private readonly overlayService: OverlayService) {
    this.overlay$ = this.overlayService.overlay$;
  }
}
